import { ActionResult, Maybe } from '@varo/graphql-schema-types';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import RadioIcon from 'shared/components/RadioIcon/RadioIcon';
import Illustration, {
  IllustrationKeyType,
} from 'shared/components/vxl/Illustration/Illustration';
import { Tag, TagProps } from 'shared/components/vxl/Tag/Tag';
import BodySmBoldText from 'shared/components/vxl/typography/primary/body/BodySmBoldText';
import theme from 'shared/styles/theme';

export interface IntentCaptureRadioCardProps {
  labelText: string;
  illustration: IllustrationKeyType;
  tag?: TagProps;
  id: string;
  onPress?: () => void;
  isSelected?: boolean;
  action?: Maybe<ActionResult>;
}

const IntentCaptureRadioCard = ({
  labelText,
  illustration,
  tag,
  id,
  onPress,
  isSelected = false,
}: IntentCaptureRadioCardProps) => {
  return (
    <Pressable
      style={[styles.container, isSelected && styles.selected]}
      id={id}
      onPress={onPress}
      accessible
      accessibilityLabel={labelText}
      accessibilityRole="radio"
    >
      <View style={styles.contentContainer}>
        <RadioIcon selected={isSelected} />
        <View style={styles.contentInner}>
          <BodySmBoldText style={styles.labelText}>{labelText}</BodySmBoldText>
          {tag ? <Tag text={tag.text} type={tag.type} /> : null}
        </View>
      </View>
      <View style={styles.illustrationContainer}>
        <Illustration illustration={illustration} />
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: theme.color.background.primary,
    borderColor: theme.color.border.primary,
    borderRadius: 4,
    borderWidth: 1,
    flex: 1,
    flexDirection: 'row',
    gap: theme.spacing.m,
    justifyContent: 'space-between',
    padding: theme.spacing.m,
  },
  contentContainer: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    gap: theme.spacing.m,
  },
  contentInner: {
    flex: 1,
    gap: theme.spacing.xs,
  },
  illustrationContainer: {
    height: 56,
    width: 56,
  },
  labelText: {
    color: theme.color.interactive.primary,
  },
  selected: {
    borderColor: theme.color.interactive.primary,
  },
});

export default IntentCaptureRadioCard;
